(function() {
  const venues = [
    {
      name: "Sadler's Wells Theatre",
      slug: "sadlers-wells-theatre"
    },
    {
      name: "Sadler's Wells East",
      slug: "sadlers-wells-east"
    },
    {
      name: "Peacock Theatre",
      slug: "peacock-theatre"
    },
    {
      name: "Lilian Baylis",
      slug: "lilian-baylis-studio"
    },
    {
      name: "Digital Stage",
      slug: "digital-stage"
    }
  ];

  let page = document.querySelector(".tn-events-detail-page");
  if(page) {
    let location = page.querySelector(".tn-event-detail__location");
    if(location) {
      venues.forEach(venue => {
        if(location.innerText.indexOf(venue.name) > -1) {
            page.classList.add("u-venue-" + venue.slug);
        }
      })
    }
  }
}());